module.exports = __webpack_public_path__ + "img/white2.9a608717.svg";